/**
 * Add a CSS variable to the body element to allow for the scrollbar width to be calculated.
 */

let maxScrollbarWidth = 0;

export function measureScrollbarWidth() {
	const currentScrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
	maxScrollbarWidth = Math.max( maxScrollbarWidth, currentScrollbarWidth );
	document.body.style.setProperty( '--wdg-scrollbar-width-max', `${ maxScrollbarWidth }px` );
	document.body.style.setProperty( '--wdg-scrollbar-width', `${ currentScrollbarWidth }px` );
}

window.addEventListener( 'resize', measureScrollbarWidth );
( new MutationObserver( measureScrollbarWidth ) ).observe(
	document.body,
	{
		attributes: true,
		attributeFilter: [ 'class' ], // Body class change (disable-body-scroll)
	}
);
measureScrollbarWidth();

